import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { TreatmentPlan as TreatmentPlanType, TreatmentPlanListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

type TreatmentPlanEntity = TreatmentPlanType
type TreatmentPlanEntityListResult = { hits: TreatmentPlanEntity[]; total: number; page: number }

const LIST_QUERY = graphql(`
  query TreatmentPlans($search: String, $pagination: PaginationInput, $sort: SortInput) {
    treatmentPlans(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        workspaceId
        locationId
        vendor
        vendorId
        patientId
        displayName
        state
        status
        procedureIds
        procedureFeeOverrides
        planCreateDate
        planUpdateDate
        createdDate
        updatedDate
        version
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query TreatmentPlan($id: ID!) {
    treatmentPlan(id: $id) {
      id
      orgId
      workspaceId
      locationId
      vendor
      vendorId
      patientId
      displayName
      state
      status
      procedureIds
      procedureFeeOverrides
      planCreateDate
      planUpdateDate
      createdDate
      updatedDate
      version
    }
  }
`)

export class TreatmentPlanStore extends EntityStore<TreatmentPlanEntity, TreatmentPlanEntityListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      extractList: (data: any) => data.treatmentPlans,
      extractOne: (data: any) => data.treatmentPlan,
    })
  }
}
